import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClear = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_b_46_22049)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				y: .897217,
				width: 20,
				height: 20,
				rx: 10,
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.771 7.12576L6.22835 14.6684",
				stroke: "white",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.771 14.6684L6.22835 7.12577",
				stroke: "white",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_b_46_22049",
		x: -33.9785,
		y: -33.0813,
		width: 87.957,
		height: 87.957,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				in: "BackgroundImageFix",
				stdDeviation: 16.9893
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "SourceAlpha",
				operator: "in",
				result: "effect1_backgroundBlur_46_22049"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_backgroundBlur_46_22049",
				result: "shape"
			})
		]
	}) })]
});
export default SvgClear;
